import React, { useState, useEffect } from 'react'
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { toast } from 'react-toastify';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import Subject from '../../components/Subject';

const StudentUpload = () => {

  const navigate = useNavigate();

  const { id } = useParams();

  const [videoFile, setVideoFile] = useState(null); 
  const [videoDuration, setVideoDuration] = useState(0); 
  const [isvideo, setIsvideo] = useState(false); 
  const [loading, setLoading] = useState(false); 

  const { studentInfo } = useSelector((state) => state.authStudent);

  useEffect(() => {
    if(!studentInfo) {
      navigate('/studentlogin')
    }
  }, [navigate, studentInfo])

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type == 'video/mp4' ||  file.type == 'video/quicktime' || file.type == 'video/avi') { 
        setIsvideo(true); 
        setVideoFile(event.target.files[0]); 
        const videoUrl = URL.createObjectURL(file);
        const videoElement = document.createElement('video');
        videoElement.src = videoUrl;
        videoElement.addEventListener('loadedmetadata', () => {
          setVideoDuration(videoElement.duration);
          URL.revokeObjectURL(videoUrl);
        });
      } 
    } 
  };
  
  const submitHandler = (event) => {
    event.preventDefault();
    setLoading(true);
    if (isvideo) {
      var fd = new FormData();
      fd.append('upl', videoFile);
      fd.append('id', id);
      fetch('/api/upload',
      {
        method: 'post',
        body: fd,
      })
      .then(response => response.json())
      .then(data => {
        setLoading(false);
        navigate(`/studentsubjects`)
        toast.success('Video Saved');
      })
      .catch(error => {
        toast.success('Error uploading video');
      });
    } else {  
      toast.error('Please upload a mp4 or quicktime or avi video file');  
    }
  };

  return (
    <div>
      <StudentNavbar />
        <div className="main-content" id="panel">
            <StudentHeader /><br /><br /><br /><br />
            <div className="container-fluid mt--6">
                <div className="row">
                <div className="col-xl-8 offset-xl-2 ">  
                <div className="card-wrapper ">
                      <div className="card profileCard2"> <br />
                        <h2 className="centerTitle tittleColor4 ">
                          <span className='tittleColor4'>
                            Upload a video
                          </span>
                          <p className="tittleColor4 ">
                                (You can upload up to 5 minutes of video)
                          </p>
                        </h2><br />
                        {loading ? ( 
                          <Loader />
                        ) : (  

                        <div className="card-body">
                          <Form onSubmit={submitHandler}>
                            <div className="form-group">
                              <input 
                                type="file" 
                                className="form-control" 
                                onChange={handleFileChange} 
                              />
                            </div>
                            <div className='col-xl-3 offset-xl-4 '>
                              <Button type='submit' disabled={videoDuration >= 300} variant='success' className=' uploadBtn btn btn-primary btn-lg btn-block rounded-pill bg-gradient-info uploadVid'>
                              Upload
                              </Button><br /><br /><br />
                              </div>
                          </Form>
                        </div>                        
                        )} 
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default StudentUpload
